import React, { useEffect, useState } from "react";
import Layout, { Header } from "antd/lib/layout/layout";
import { Avatar, Badge, Col, Menu, Popover, Row } from "antd";
import {
  LayoutFilled,
  HomeFilled,
  HddFilled,
  SettingFilled,
  UserOutlined,
  ContactsFilled,
  SignalFilled,
  DashboardFilled,
  SmileFilled,
} from "@ant-design/icons";
import type { MenuProps } from "antd";
import Text from "../Text/Text";
import color from "../../resource/color";
import { Outlet, useNavigate } from "react-router";
import { AuthDatasource } from "../../datasource/loginDatasource";
import { useSearchParams } from "react-router-dom";
import { PermissionReportDatasource } from "../../datasource/permissionReportDatasource";
import { EmployeeApproveDatasource } from "../../datasource/EmploeeApprove";
import { COMPAY_MAPPING_DES } from "../../definitions/Company";
import image from "../../resource/image";

const Layouts: React.FC = () => {
  const navigate = useNavigate();
  const [searchParams] = useSearchParams();
  const token = searchParams.get("token") || "";
  const permission = localStorage.getItem("rainbowPermission") || "";
  const profileData = JSON.parse(localStorage.getItem("rainbowProfile")!);

  useEffect(() => {
    if (token) {
      localStorage.setItem("rainbowToken", token);
    }
  }, [token]);

  const [profile, setProfile] = useState<any>();
  const [loading, setLoading] = useState<boolean>(true);
  const [checkManager, setCheckManager] = useState<boolean>(false);

  const login = async () => {
    await AuthDatasource.getEmployeeByToken(
      localStorage?.getItem("rainbowToken") || "",
    ).then(async (emp) => {
      if (emp?.success) {
        let img = emp?.responseData?.imagePath?.split("\\");
        img = img && img[img.length - 1];
        localStorage.setItem(
          "rainbowProfile",
          JSON.stringify({
            ...emp.responseData,
            linkImage:
              `http://system.icpladda.com/EmployeeProfileImage/${img}` || "",
          }),
        );
        setProfile({
          ...emp.responseData,
          linkImage:
            `http://system.icpladda.com/EmployeeProfileImage/${img}` || "",
        });
        await PermissionReportDatasource.getPermissionByEmpId(
          emp.responseData.employeeId,
        ).then((res) => {
          if (res.success) {
            localStorage.setItem(
              "rainbowPermission",
              JSON.stringify(res.responseData),
            );
          } else {
            localStorage.setItem("rainbowPermission", JSON.stringify(null));
          }
        });
        setLoading(false);
        const manager = await EmployeeApproveDatasource.getEmployeeApprove(
          emp.responseData.employeeId,
        ).then((res) => {
          return res.responseData;
        });
        setCheckManager(manager?.length > 0 ? true : false);
      } else {
        window.location.href = "https://system.icpladda.com/";
      }
    });
  };

  useEffect(() => {
    login();
  }, []);

  let menus: any = [
    {
      label: <Text fontWeight={700}>Home</Text>,
      key: "",
      icon: <HomeFilled style={{ fontSize: "25px" }} />,
    },
    {
      label: <Text fontWeight={700}>Self-Reflection</Text>,
      key: "self",
      icon: <LayoutFilled style={{ fontSize: "25px" }} />,
    },
    ...(checkManager
      ? [
          {
            label: <Text fontWeight={700}>PMS</Text>,
            key: "pms",
            icon: <HddFilled style={{ fontSize: "25px" }} />,
          },
        ]
      : []),
    {
      label: <Text fontWeight={700}>My Evaluation</Text>,
      key: "myEvaluation",
      icon: <SmileFilled style={{ fontSize: "25px" }} />,
    },
    {
      label: <Text fontWeight={700}>KCI</Text>,
      key: `kci/${
        COMPAY_MAPPING_DES[`${profileData?.companyId}`] ||
        profileData?.companyList?.find(
          (x: any) => `${x?.companyId}` === `${profileData?.companyId}`,
        ).companyCode
      }`,
      icon: <DashboardFilled style={{ fontSize: "25px" }} />,
    },
  ];

  const approvalMenu: any = {
    label: <Text fontWeight={700}>Approval Setting</Text>,
    key: "approvalEmployee",
    icon: <ContactsFilled style={{ fontSize: "25px" }} />,
  };
  const settingMenu: any = {
    label: <Text fontWeight={700}>Conditions Setting</Text>,
    key: "setting",
    icon: <SettingFilled style={{ fontSize: "25px" }} />,
    children: [
      {
        label: <Text fontWeight={700}>Self-Reflection Condition</Text>,
        key: "selfCondition",
        icon: <SettingFilled style={{ fontSize: "25px" }} />,
      },
      {
        label: <Text fontWeight={700}>Score Condition</Text>,
        key: "scoreCondition",
        icon: <SettingFilled style={{ fontSize: "25px" }} />,
      },
    ],
  };
  const reportMenu: any = {
    label: <Text fontWeight={700}>Reports</Text>,
    key: "report",
    icon: <SignalFilled style={{ fontSize: "25px" }} />,
    children: [
      {
        label: <Text fontWeight={700}>PMS Report</Text>,
        key: "managerPmsReport",
        icon: <HddFilled style={{ fontSize: "25px" }} />,
      },
      {
        label: <Text fontWeight={700}>Self-Reflection Summary</Text>,
        key: "selfReport",
        icon: <SignalFilled style={{ fontSize: "25px" }} />,
      },
      {
        label: <Text fontWeight={700}>PMS Summary</Text>,
        key: "pmsReport",
        icon: <SignalFilled style={{ fontSize: "25px" }} />,
      },
      // {
      //   label: <Text fontWeight={700}>KCI Report</Text>,
      //   key: "kciReport",
      //   icon: <PieChartFilled style={{ fontSize: "25px" }} />,
      // },
      {
        label: <Text fontWeight={700}>Permission Report Setting</Text>,
        key: "permissionReportSetting",
        icon: <SettingFilled style={{ fontSize: "25px" }} />,
      },
    ],
  };

  const menuPermission = () => {
    const conditionG = [4, 1, 16, 1489, 1527, 1389];
    const approveG = [
      4, 1, 16, 1489, 2, 1302, 1517, 1315, 1146, 1207, 2921, 1737, 1527, 1389,
      135, 14, 1278,
    ];
    const reportG = [4, 1, 16, 1489, 1527, 1389];
    const setting = conditionG.includes(Number(profile.employeeId));
    const approvalEmployee = approveG.includes(Number(profile.employeeId));
    const report = reportG.includes(Number(profile.employeeId));

    if (setting) {
      menus.push(settingMenu);
    }
    if (approvalEmployee) {
      menus.push(approvalMenu);
    }
    if (checkManager) {
      menus.push({
        ...reportMenu,
        children: reportMenu?.children?.filter(
          (x: any) => x.key === "managerPmsReport",
        ),
      });
    }

    let jsonPermission = JSON.parse(permission);
    if (jsonPermission && jsonPermission.permission.length > 0) {
      const findReport: any = menus.find((m: any) => m.key === "report");
      if (findReport) {
        const map = jsonPermission.permission.map((perm: any) => {
          return reportMenu?.children.find((x: any) => {
            if (perm.reportName === "Self-Reflection Report") {
              return x.key === "selfReport";
            } else if (perm.reportName === "PMS Report") {
              return x.key === "pmsReport";
            } else {
              return x;
            }
          });
        });

        const newMap = (menus as any).map((m: any) => {
          if (m.key === "report") {
            return {
              ...m,
              children: [...m.children, ...map],
            };
          }
          return m;
        });
        menus = newMap;
      } else {
        menus.push({
          ...reportMenu,
          children: jsonPermission.permission.map((perm: any) => {
            return reportMenu?.children.find((x: any) => {
              if (perm.reportName === "Self-Reflection Report") {
                return x.key === "selfReport";
              } else if (perm.reportName === "PMS Report") {
                return x.key === "pmsReport";
              } else {
                return;
              }
            });
          }),
        });
      }
    }

    if (report) {
      const newMap = menus.map((m: any) => {
        if (m.key === "report") {
          return {
            ...m,
            children: [
              ...m.children,
              reportMenu?.children?.find(
                (x: any) => x.key === "permissionReportSetting",
              ),
            ],
          };
        }
        return m;
      });
      menus = newMap;
    }
    return menus;
  };

  const text = (
    <Text fontSize={16} fontWeight={700} color="white">
      ประวัติ
    </Text>
  );
  const content = (
    <div>
      <Text fontSize={14} fontWeight={500} color="white">
        Employee Code : {profile?.employeeCode}
      </Text>
      <br />
      <Text fontSize={14} fontWeight={500} color="white">
        Nick Name: {profile?.nickname}
      </Text>
      <br />
      <Text fontSize={14} fontWeight={500} color="white">
        Position: {profile?.position?.positionName}
      </Text>
    </div>
  );
  if (loading) {
    return <></>;
  } else {
    return (
      <>
        <Layout>
          <Header
            style={{
              position: "sticky",
              top: 0,
              zIndex: 9,
              width: "100%",
              alignItems: "center",
              backgroundColor: color.white,
            }}
          >
            <Row>
              <Col span={22}>
                <Menu
                  mode="horizontal"
                  items={menuPermission()}
                  theme="light"
                  defaultOpenKeys={["self"]}
                  onClick={(e) => navigate(`/${e.key}`)}
                />
              </Col>
              <Col span={1}>
                <Avatar
                  src={image?.rainbowLogo}
                  shape="square"
                  size={45}
                  style={{
                    backgroundColor: color.lightgray,
                    cursor: "pointer",
                  }}
                  onClick={() =>
                    (window.location.href =
                      "https://system.icpladda.com/Home/Index")
                  }
                />
              </Col>
              <Col span={1}>
                <Badge count={profile?.jbType}>
                  <Popover
                    placement="bottomRight"
                    title={text}
                    content={content}
                    trigger="click"
                    color={"black"}
                  >
                    <Avatar
                      src={profile?.linkImage}
                      icon={<UserOutlined />}
                      shape="square"
                      size={45}
                      style={{ backgroundColor: color.orange }}
                    />
                  </Popover>
                </Badge>
              </Col>
            </Row>
          </Header>
          <Outlet />
        </Layout>
      </>
    );
  }
};

export default Layouts;
